import React, { Component } from 'react';
import { connect } from 'react-redux';
import DonorSeaComponent from '../Components/Donor/DonorSeaComponent';
// import DonorListPlatinum from '../Components/Donor/DonorListPlatinum.jsx';
import _ from 'lodash';
import { safeJson } from '../utils/dataHelpers';
import { loopIndex, getFileType, videoType, dp } from '../utils/shared';
import timeHelpers from '../utils/timeHelpers.js';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { logToServer } from '../actions/display.js';

window.tmpLogArray = [];
const _videoStyle = {
  preload: 'auto',
  position: 'fixed',
  minWidth: '100%',
  minHeight: '100%',
  width: '100%',
  height: '100%',
  zIndex: -100,
  loop: '',
  autoplay: "",
  muted: "",
  pointerEvents: "none"
}
const FADED_IN = "faded_in";
const FADED_OUT = "faded_out";
const FADE_DELAY = 2000;

class DonorContainer extends Component {
  constructor(props) {
    super(props);

    try {

      this._intervalsToKeepOneWaveOfDonorsOnScreen = 2;
      this._intervalDonorsTimeoutHandler = null;
      this._donorsNameStarterIntervalHandler = null;
      this._intervalTimeout = null;
      this._intervalDonorsTimeoutMS = 0;
      this._donorNamesStatus = FADED_OUT;
      this._donorStateElementIndex = null;
      this._justFadedNamesOut = false;
      this._timeToFadeDonorsIn = 3000;
      this._timeToFadeDonorsOut = 3000;
      this._donorsAreReady = false;
      this._donorsNameStarterTimeout = 0;
  
      this._timeToFadeDonors = 5000;
      this._elemCounter = 1;
      this._seaConfig = null;
      this._cycleIntervals = null;
      this._donorSeaRef = null;
      this._intervalDonorCounter = 0;
  
      this._config = {
        elementIntervalMS: null,
        elementStates: []
      }
  
      // Search for a Donor Sea Type of Module
      let rootFolder = _.get(this.props.content, 'settings.selected_root_folder', null);
      rootFolder = Number(rootFolder);
      let parentFolder = _.find(this.props.content.story_categories, (folder) => {
        let type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
        return type === "attract_loop_donor_lists" && folder.parent_category === rootFolder
      });
      let donorListsFolder = _.filter(this.props.content.story_categories, { contents: { custom_fields: { folder_type: { val: { value: "donor_lists" } } } }, parent_category: parentFolder.id });
      donorListsFolder = donorListsFolder[0] ? donorListsFolder[0] : null;
      let platinumDiamondLists = _.filter(this.props.content.story_categories, (folder) => {
        let type = _.get(folder.contents, 'custom_fields.folder_type.val.value', null);
        return folder.parent_category === donorListsFolder.id && type === 'donor_list_turbot';
      });
  
      let index = _.findIndex(this.props.content.dm_active, { display_module_type: "Donor Sea" });
      this._donorSeaModuleIndex = index;
      // this._donorSea = this.props.content.dm_active[index];
      this._donorSea = donorListsFolder;
  
      if (this._donorSea === undefined || this._donorSea === null) {
        console.log("No Donor Sea module was found");
      } else {
        let slideshow_module = _.find(this.props.content.dm_active, { id: Number(this._donorSea.contents.custom_fields.assets.val.value) });
        this._cycleIntervals = [];
        let cycleIntervals = _.get(slideshow_module, 'contents.cycle_overrides', []).filter((v, i) => i % 2 === 0);
        cycleIntervals = cycleIntervals.map(interval => (interval * 1000));
  
        let activeSlides = _.get(slideshow_module, 'contents.bool0s', []).filter((v, i) => i % 2 === 0);
  
        this._seaConfig = this._donorSea.contents;
        let timeToFadeDonorsIn = _.get(this._seaConfig, 'custom_fields.timeToFadeDonorsIn.val', 3);
        let timeToFadeDonorsOut = _.get(this._seaConfig, 'custom_fields.timeToFadeDonorsOut.val', 3);
  
        this._timeToFadeDonorsIn = timeToFadeDonorsIn * 1000;
        this._timeToFadeDonorsOut = timeToFadeDonorsOut * 1000;
        this._timeToFadeDiamondPlatinumDonorsIn = 3000;
        this._timeToFadeDiamondPlatinumDonorsOut = 3000;
        this._regionMarginFromEdges = _.get(this._seaConfig, 'custom_fields.regionMarginFromEdges.val', 2);
        this._regionMarginFromTopAndBottom = _.get(this._seaConfig, 'custom_fields.regionMarginFromTopAndBottom.val', 2);
        this._minMarginBetweenNamesHorizontally = _.get(this._seaConfig, 'custom_fields.minMarginBetweenNamesHorizontally.val', 5);
        this._minMarginBetweenNamesVertically = _.get(this._seaConfig, 'custom_fields.minMarginBetweenNamesVertically.val', 3);
  
        this._intervalsToKeepOneWaveOfDonorsOnScreen = _.get(this._seaConfig, 'custom_fields.intervalsToKeepOneWaveOfDonorsOnScreen.val', 2);
        let elementStates = slideshow_module.contents.images.filter((v, i) => i % 2 !== 0);
        this._config.elementStates = [];
  
        //only push active slides to array
        for (var b = 0; b < elementStates.length; b++) {
          if (activeSlides[b]) {
            if (activeSlides[b] === true || activeSlides[b] === 'true') {
              this._config.elementStates.push({ ...elementStates[b], cycleInterval: cycleIntervals[b] || 5000 });
              if (cycleIntervals[b]) {
                this._cycleIntervals.push(cycleIntervals[b]);
              }
              else {
                this._cycleIntervals.push(5000);
              }
            }
          }
        }

        // console.log(this._cycleIntervals);
  
        this._slideshowConfig = slideshow_module.contents;
        if (this._config.elementStates.length === 1) {
          this._config.elementStates.push(this._config.elementStates[0]); //make an array of at least two for the purposes of transitions
        }
  
        this._intervalTimeoutMS = timeHelpers.timeIntervalRemainderArrayMS(this._cycleIntervals);
      }
  
      let elementIndex = timeHelpers.indexFromIntervalArray(this._cycleIntervals, this._config.elementStates.length);
      let currentTimeInterval = timeHelpers.currentSeekTimeArray(this._cycleIntervals);
  
      this.state = {
        elementIndex: elementIndex,
        currentTimeInterval: currentTimeInterval,
        fadeInDonors: false,
        nameCount: 0,
        namesDisplayed: 0,
        secondsPassed: 0,
        sinceElement: 0,
        showDebug: false,
        contentStage: 2,
        showPlatinumAndDiamond: false,
        platinumDiamondLists: platinumDiamondLists
      };
  
      this._currentVideoRef = null;
      this._intervalTimeout = null;
      this._intervalSeekTimeout = null;
      this._startTime = new Date();
      this._elementCycleTime = new Date();
    } catch(e) {
      console.log(e);
    }
  }

  componentDidMount() {
    this.props.logToServer([new Date() + " Component just mounted"], "DonorContainer", this.props.content.id, this.props.screen.mode, this.props.screen.webkey);
    this.setupIntervalHandler();
    this.donorsNameStarter();
    this.setVideoSeekTimeInterval();
    document.addEventListener("keydown", this.handleKeyDown);
  }

  donorsNameStarter = () => {
    this._donorsNameStarterIntervalHandler = setTimeout(() => {
      if (this._donorsAreReady) {
        this.setupDonorNamesInterval();
      } else {
        this._donorsNameStarterTimeout = 1000;
        this.donorsNameStarter();
      }
    }, this._donorsNameStarterTimeout);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    clearTimeout(this._intervalTimeout);
    clearTimeout(this._intervalSeekTimeout);
    clearTimeout(this._intervalDonorsTimeoutHandler);
    clearTimeout(this._donorsNameStarterIntervalHandler);
    this._intervalTimeout = null;
    this._intervalSeekTimeout = null;
    this._intervalDonorsTimeoutHandler = null;
    this._donorsNameStarterIntervalHandler = null;
  }

  handleKeyDown = (event) => {
    switch (event.key) {
      case "s":
        console.log(this.props);
        break;
      case "d":
        console.log("pressed");
        this.setState({
          showDebug: !this.state.showDebug
        });
        break;
      //   let newDebug = this.state.showDebug + 1
      //   if (newDebug > 2) {
      //     newDebug = 0
      //   }
      //   this.setState({
      //     showDebug: newDebug
      //   })
      //   break;
      // case "n":
      //   if (this.state.contentStage === 0) { //fade out names
      //     this.setState({
      //       contentStage: 1
      //     })
      //   }
      //   else if (this.state.contentStage === 2) { //start names fade in
      //     this.setState({
      //       contentStage: 0
      //     })
      //   }
      //   break;
      default:
        break;
    }
  }

  setDonorsReady = (status) => {
    this._donorsAreReady = status;
  }

  setupIntervalHandler = () => {
    window.tmpLogArray.push(new Date() + " Creating Timeout");
    window.tmpLogArray.push(new Date() + " Current index is: " + this.state.elementIndex);
    clearTimeout(this._intervalTimeout);
    this._intervalTimeout = setTimeout(() => {
      this._intervalTimeoutMS = timeHelpers.timeIntervalRemainderArrayMS(this._cycleIntervals, true);
      window.tmpLogArray.push(new Date() + " Time for the next Cycle: " + this._intervalTimeoutMS);

      if (this._intervalTimeoutMS > 500) {
        let elementIndex = loopIndex(this.state.elementIndex, 0, this._config.elementStates.length - 1, "forward");
        let showOverlay = elementIndex === this._config.elementStates.length - 1 ? false : true;

        // console.log("Next element Index", elementIndex);
        window.tmpLogArray.push(new Date() + " Next element Index: " + elementIndex);
        this.props.logToServer(window.tmpLogArray, 'DonorContainer', this.props.content.id, this.props.screen.mode, this.props.screen.webkey);
        window.tmpLogArray = [];
        
        this.setState({
          showOverlay: showOverlay,
          elementIndex: elementIndex
        });
        if (elementIndex !== (this._config.elementStates.length - 1)) {
          this._elemCounter++;
        }
        // console.log("Element Counter", this._elemCounter);
        // console.log("Changing video to", elementIndex);
        clearTimeout(this._intervalDonorsTimeoutHandler);
        this._intervalDonorsShowTimeoutHandler = setTimeout(() => {
          if (this._donorsAreReady) {
            this.setupDonorNamesInterval(elementIndex);
          }
        }, FADE_DELAY);
      }

      this.setupIntervalHandler();
    }, this._intervalTimeoutMS);
  }

  setupDonorNamesInterval = (elementIndex) => {
    if (elementIndex === undefined || elementIndex === null) {
      elementIndex = this.state.elementIndex;
    }

    let minTimeLeftToShowDonors = this._timeToFadeDonorsIn + this._timeToFadeDonorsOut;
    this._intervalDonorsTimeoutMS = timeHelpers.timeIntervalRemainderArrayMS(this._cycleIntervals);
    let timeToCheckDonors = this._intervalDonorsTimeoutMS - this._timeToFadeDonorsOut - FADE_DELAY;
    let showPlatinumAndDiamond = false;
    let loopWave = false;

    if (elementIndex !== (this._config.elementStates.length - 1) && this._donorNamesStatus === FADED_OUT) {
      if (this._intervalDonorsTimeoutMS > minTimeLeftToShowDonors) {
        loopWave = elementIndex === 0 ? true : false;
        this._donorSeaRef.getWrappedInstance().setupFadeInDonors(loopWave);

        if (elementIndex === (this._config.elementStates.length - 1)) {
          showPlatinumAndDiamond = true;
        }
        
        // this.setState({
        //   showOverlay: !loopWave,
        // });
        // console.log("Fading In");
        this._donorNamesStatus = FADED_IN;
      }
    }

    let showOverlay = !loopWave;
    if (elementIndex === (this._config.elementStates.length - 1)) {
      showPlatinumAndDiamond = true;
      showOverlay = false;
    }
    
    this.setState({
      showPlatinumAndDiamond: showPlatinumAndDiamond,
      showOverlay: showOverlay,
    });

    // Fade out Platinum donors with a 10% delay
    clearTimeout(this._intervalPlatinumHandler);
    this._intervalPlatinumHandler = setTimeout(() => {
      this.setState({
        showPlatinumAndDiamond: false
      });
    }, timeToCheckDonors * 1.2);
    
    clearTimeout(this._intervalDonorsTimeoutHandler);
    this._intervalDonorsTimeoutHandler = setTimeout(() => {
      let nextElement = loopIndex(elementIndex, 0, this._config.elementStates.length - 1, "forward");
      if ((this._elemCounter === Number(this._intervalsToKeepOneWaveOfDonorsOnScreen)) || (nextElement === this._config.elementStates.length - 1)) {
        this._donorSeaRef.getWrappedInstance().setupFadeOutDonors();
        this._donorNamesStatus = FADED_OUT;
        this._elemCounter = 0;
      }
    }, timeToCheckDonors);
  }

  setVideoSeekTimeInterval = () => {
    clearTimeout(this._intervalSeekTimeout);
    this._intervalSeekTimeout = null;
    this._intervalSeekTimeout = setTimeout(() => {
      let fileType = getFileType(this._config.elementStates[this.state.elementIndex].file_name);
      if (fileType === "video") {
        if (!this._currentVideoRef) {
          this.setVideoSeekTimeInterval();
        } else {
          this._currentVideoRef.currentTime = (this.state.currentTimeInterval / 1000);
          clearTimeout(this._intervalSeekTimeout);
        }
      }
    }, 30);
  }

  showBezelHandle = (xScreens, yScreens) => {
    if (this.state.showDebug === false) {
      return (
        null
      )
    }

    let debugBoxStyle = {
      position: 'absolute',
      opacity: .7,
      backgroundColor: "black"
    }

    // Determine Horizontal Lines based on amount of V Screens.
    let hLines = Array.apply(null, { length: (yScreens + 1) }).map(Number.call, Number);
    let vLines = Array.apply(null, { length: (xScreens + 1) }).map(Number.call, Number);

    let regionHeight = this.props.screen.screenHeight / yScreens;
    let regionWidth = this.props.screen.screenWidth / xScreens;
    let bezel = this.props.screen.screenHeight * .005;

    let renderedHlines = hLines.map((lNumber, key) => {
      let bezelOffset = lNumber > 0 ? bezel / 2 : 0;
      bezelOffset = lNumber === (hLines.length - 1) ? bezel : bezelOffset;
      let style = {
        top: lNumber * regionHeight - bezelOffset,
        left: 0,
        height: bezel,
        width: this.props.screen.screenWidth
      }

      return (
        <div key={key} style={{ ...debugBoxStyle, ...style }}></div>
      );
    });

    let renderedVlines = vLines.map((lNumber, key) => {
      let bezelOffset = lNumber > 0 ? bezel / 2 : 0;
      bezelOffset = lNumber === (vLines.length - 1) ? bezel : bezelOffset;
      let style = {
        left: lNumber * regionWidth - bezelOffset,
        top: 0,
        width: bezel,
        height: this.props.screen.screenHeight
      }

      return (
        <div key={key} style={{ ...debugBoxStyle, ...style }}></div>
      );
    });

    return (
      <div>
        {renderedVlines}
        {renderedHlines}
      </div>
    );
  }

  render() {
    try {
      let fileType = getFileType(this._config.elementStates[this.state.elementIndex].file_name);
      let cType = "";
      let content = "";

      let donorSeaBox = {
        left: 0,
        top: 0,
        width: this.props.screen.screenWidth,
        height: this.props.screen.screenHeight
      }

      // let fullpath = dpath(this.props.screen.mode, this._config.elementStates[this.state.elementIndex].path, this._config.elementStates[this.state.elementIndex].file_name, this.props.screen.webkey);
      let fullpath = dp(this.props.screen, this._config.elementStates[this.state.elementIndex], null);

      if (fileType === "video") {
        cType = videoType(this._config.elementStates[this.state.elementIndex].file_name);
        content = (<div className="vid" style={{ position: 'absolute', top: 0, left: 0 }} key={this.state.elementIndex}>
          <video style={_videoStyle} ref={el => this._currentVideoRef = el} id="background-video" loop autoPlay muted>
            <source src={fullpath} type={cType} />
            Your browser does not support the video tag.
                                </video>
        </div>);
      } else {
        content = (<div style={{ ...donorSeaBox, zIndex: -100, position: 'absolute', backgroundSize: "cover", backgroundImage: "url(" + fullpath + ")" }} />);
      }

      let opacity = Number(_.get(this._slideshowConfig.custom_fields, 'overlay_opacity_horizontal.val', 0));
      let overlayCss = {
        backgroundColor: _.get(this._slideshowConfig.custom_fields, 'overlay_color_horizontal.val', '#FFFFFF'),
        opacity: opacity !== 0 ? opacity / 100 : opacity,
        position: 'absolute',
        width: this.props.screen.screenWidth,
        height: this.props.screen.screenHeight
      }

      return (
        <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }}>
          {/* Show Screens Bezel */}
          <div key={this.state.showDebug}>
            {this.showBezelHandle(this._seaConfig.custom_fields.screensH.val, this._seaConfig.custom_fields.screensV.val)}
          </div>
          
          <CSSTransitionGroup
            component='div'
            transitionName='slowfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.elementIndex}>
              {content}
            </div>
          </CSSTransitionGroup>

          <CSSTransitionGroup
            component='div'
            transitionName='slowfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.showOverlay}>
              {
                this.state.showOverlay ?
                  <div style={overlayCss}></div> : null
              }
            </div>
          </CSSTransitionGroup>
          {/* {
            this.state.platinumDiamondLists.map((list, i) => {
              return (
                <DonorListPlatinum
                  key={i}
                  donorCategories={this.props.donors}
                  folderModules={this.props.content.folder_modules}
                  stories={this.props.content.stories}
                  showDonors={this.state.showPlatinumAndDiamond}
                  folderId={list.id}
                  columns={Number(_.get(list, 'contents.custom_fields.columns_screen.val', 2))}
                  rows={Number(_.get(list, 'contents.custom_fields.rows_screen.val', 7))}
                  screensH={Number(_.get(list, 'contents.custom_fields.screens_h.val', 1))}
                  screensV={Number(_.get(list, 'contents.custom_fields.screens_v.val', 1))}
                  totalScreensH={this._seaConfig.custom_fields.screensH.val}
                  totalScreensV={this._seaConfig.custom_fields.screensV.val}
                  allowedScreens={this.props.allowedScreens}
                  screenLocationH={Number(_.get(list, 'contents.custom_fields.screen_h_location.val', 1))}
                  screenLocationV={Number(_.get(list, 'contents.custom_fields.screen_v_location.val', 1))}
                  regionMarginFromEdges={Number(_.get(list, 'contents.custom_fields.regionMarginFromEdges.val', 2))}
                  regionMarginFromTopAndBottom={Number(_.get(list, 'contents.custom_fields.regionMarginFromTopAndBottom.val', 2))}
                  rightMarginColumn={Number(_.get(list, 'contents.custom_fields.rightMarginColumn.val', 0))}
                  leftMarginColumn={Number(_.get(list, 'contents.custom_fields.leftMarginColumn.val', 0))}
                  titleText={_.get(list, 'contents.custom_fields.title_text.val', "Thank")}
                  titleText2={_.get(list, 'contents.custom_fields.title_text_2.val', "You")}
                  titleTextStyle={_.get(list, 'contents.custom_fields.vertical_word_style', {})}
                  titleTextStyle2={_.get(list, 'contents.custom_fields.vertical_word_style_2', {})}
                  donorNameStyle={_.get(list, 'contents.custom_fields.donor_name_style', {})}
                  wordMarginBottom={_.get(list, 'contents.custom_fields.wordMarginBottom.val', 2)}
                  screen={this.props.screen}
                />
              );
            })} */}

          <DonorSeaComponent
            ref={el => this._donorSeaRef = el}
            activeModuleIndex={this._donorSeaModuleIndex}
            screensH={this._seaConfig.custom_fields.screensH.val}
            screensV={this._seaConfig.custom_fields.screensV.val}
            allowedScreens={this.props.allowedScreens}
            timeToFadeDonors={this._timeToFadeDonors}
            timeToFadeDonorsIn={this._timeToFadeDonorsIn}
            timeToFadeDonorsOut={this._timeToFadeDonorsOut}
            fadeDonors={this.state.fadeDonors}
            regionMarginFromEdges={this._regionMarginFromEdges}
            regionMarginFromTopAndBottom={this._regionMarginFromTopAndBottom}
            minMarginBetweenNamesHorizontally={this._minMarginBetweenNamesHorizontally}
            minMarginBetweenNamesVertically={this._minMarginBetweenNamesVertically}
            setDonorsReady={this.setDonorsReady} />
        </div>
      )
    } catch (e) {
      console.log(e);
    }

  }
}

const mapStateToProps = (state) => {
  let allowedScreens = { enabled: false, allowedH: [], allowedV: [] };
  if (_.has(state, 'content.settings.custom_vars.allowedH')) {
    allowedScreens.enabled = true;
    allowedScreens.allowedH = safeJson(state.content.settings.custom_vars.allowedH) || [];
  }
  if (_.has(state, 'content.settings.custom_vars.allowedV')) {
    allowedScreens.enabled = true;
    allowedScreens.allowedV = safeJson(state.content.settings.custom_vars.allowedV) || [];
  }

  return {
    content: state.content,
    donors: state.donors,
    screen: state.screen,
    active_module: state.active_module,
    allowedScreens: allowedScreens
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logToServer: (logs, type, display, mode, webkey) => dispatch(logToServer(logs, type, display, mode, webkey))
  }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(DonorContainer);


// WEBPACK FOOTER //
// ./src/containers/DonorContainer.jsx